<template>
  <component
    :is="dynamicIcon"
    :style="{
      height: `${size ?? 16}px`,
      width: 'auto',
      fill: 'currentColor',
    }"
  />
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent } from "vue";

export type Icon =
  | "archive"
  | "alert"
  | "arrow-left"
  | "arrow-right"
  | "arrow-rotate-left"
  | "availability"
  | "bank"
  | "bars"
  | "bell"
  | "binoculars"
  | "book-check"
  | "bus"
  | "calendar-check"
  | "calendar"
  | "castle"
  | "chat"
  | "check"
  | "copy"
  | "sync"
  | "email"
  | "chevron-down"
  | "chevron-expand"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "chevrons-left"
  | "chevrons-right"
  | "circle-info"
  | "close"
  | "clear"
  | "columns"
  | "delete"
  | "detail"
  | "document"
  | "edit"
  | "exclamation-mark"
  | "external-link"
  | "finance"
  | "floppy-disk"
  | "grid"
  | "grip-dots"
  | "handshake"
  | "history"
  | "lock"
  | "location"
  | "map"
  | "minus"
  | "person-flag"
  | "plus"
  | "sailboat"
  | "ship"
  | "search"
  | "sliders"
  | "spinner"
  | "thumbtack"
  | "ticket-event"
  | "ticket"
  | "trash"
  | "flow-curation"
  | "flow-base"
  | "flow-translation"
  | "flow-media"
  | "circle-dotted"
  | "underline"
  | "bold"
  | "italic"
  | "integration"
  | "integration-space"
  | "ordered-list"
  | "unordered-list"
  | "van-shuttle"
  | "image"
  | "additional-services"
  | "content-generator"
  | "customer-info"
  | "options"
  | "option-settings"
  | "pricing"
  | "settings"
  | "transfers"
  | "circle-info-solid"
  | "duplicate"
  | "info-solid"
  | "warning-solid"
  | "success-solid"
  | "error-solid"
  | "live-warning"
  | "draft"
  | "gallery"
  | "logout"
  | "languages"
  | "more"
  | "check-outline"
  | "download"
  | "file-upload"
  | "sort-arrow"
  | "preview"
  | "asterix-integration"
  | "user"
  | "api-connection"
  | "pin"
  | "configuration"
  | "hourglass"
  | "message"
  | "sun"
  | "people"
  | "people-space"
  | "moon"
  | "glossary"
  | "folder-block"
  | "refresh"
  | "share"
  | "success-dot"
  | "error-dot"
  | "restore"
  | "tag"
  | "split"
  | "cookie"
  | "link"
  | "list-check"
  | "tags";

export interface Props {
  name: Icon;
  size?: number;
}

const props = defineProps<Props>();

const dynamicIcon = computed(() => {
  const iconName = props.name;
  if (!iconName) return null;
  return defineAsyncComponent(() => import(`../../assets/svg/icon-${iconName}.svg`));
});
</script>
